import { adjustContactFormSubmitButton } from './adjust-contact-form-submit-button';
import { ViewTransition } from './view-transition';
import { VirtualWindowController } from './virtual-window-controller';

document.addEventListener('DOMContentLoaded', () => {
  adjustContactFormSubmitButton();
  const virtualWindowController = new VirtualWindowController();
  virtualWindowController.init();
  const viewTransition = new ViewTransition();
  viewTransition.init();
});
